import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { paperInventoryBussiness } from "api/bussiness/paper-material/paper-inventory";
import { downloadFile } from "commons/ultilities";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { ExportExcelDialog } from "share-components/mui-wrap/dialog/export-excel-dialog";

export const ExportExcel = observer(() => {
  const {
    paperInventoryManagement: {
      paperInventoryStore: {
        excelParams: {
          issueDateRangeFilter: {
            fromAsDayJs: fromIssueAsDayJs,
            from: fromIssue,
            to: toIssue,
            toAsDayJs: toIssueAsDayJs,
            setProp: setIssueDateRange,
          },
          receiptDateRangeFilter: {
            fromAsDayJs: fromReceiptAsDayJs,
            from: fromReceipt,
            to: toReceipt,
            toAsDayJs: toReceiptAsDayJs,
            setProp: setReceiptDateRange,
          },
          showZeroQuantity,
          setProp: setExcelParamProp,
        },
        openExportExcel,
        setProp,
      },
    },
  } = useStores();
  const handleClose = () => {
    setProp("openExportExcel", false);
  };

  const fromReceiptDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setReceiptDateRange("from", value ? value.toString() : null);
    },
    [setReceiptDateRange]
  );

  const toReceiptDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setReceiptDateRange("to", value ? value.toString() : null);
    },
    [setReceiptDateRange]
  );

  const fromIssueDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setIssueDateRange("from", value ? value.toString() : null);
    },
    [setIssueDateRange]
  );

  const toIssueDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setIssueDateRange("to", value ? value.toString() : null);
    },
    [setIssueDateRange]
  );

  const exportExcel = useCallback(async () => {
    try {
      const res = await paperInventoryBussiness.exportExcelByRollNumber({
        fromImportDate:
          fromReceiptAsDayJs?.isValid() && fromReceipt ? fromReceipt : "",
        toImportDate: toReceiptAsDayJs?.isValid() && toReceipt ? toReceipt : "",
        fromExportDate:
          fromIssueAsDayJs?.isValid() && fromIssue ? fromIssue : "",
        toExportDate: toIssueAsDayJs?.isValid() && toIssue ? toIssue : "",
        showZeroQuantity: showZeroQuantity,
      });
      downloadFile(res, `ton_kho_giay.xlsx`);
    } catch (ex) {
    } finally {
    }
  }, [
    fromIssue,
    fromIssueAsDayJs,
    fromReceipt,
    fromReceiptAsDayJs,
    showZeroQuantity,
    toIssue,
    toIssueAsDayJs,
    toReceipt,
    toReceiptAsDayJs,
  ]);
  return (
    <ExportExcelDialog
      open={openExportExcel}
      handleClose={handleClose}
      exportBtnDisabled={false}
      exportHandler={exportExcel}
    >
      <Stack direction={"column"} spacing={2}>
        <Stack direction={"row"} sx={{ paddingTop: 1 }}>
          <DateRange
            label={"Ngày nhập kho"}
            fromDate={fromReceiptAsDayJs}
            toDate={toReceiptAsDayJs}
            onFromDateChanged={fromReceiptDateChangedHandler}
            onToDateChanged={toReceiptDateChangedHandler}
          ></DateRange>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <DateRange
            label={"Ngày xuất kho"}
            fromDate={fromIssueAsDayJs}
            toDate={toIssueAsDayJs}
            onFromDateChanged={fromIssueDateChangedHandler}
            onToDateChanged={toIssueDateChangedHandler}
          ></DateRange>
        </Stack>

        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showZeroQuantity}
                onChange={(_e, checked) =>
                  setExcelParamProp("showZeroQuantity", checked)
                }
              />
            }
            label="Gồm tồn bằng 0"
          />
        </Stack>
      </Stack>
    </ExportExcelDialog>
  );
});
